import { DownloadBusinessPlanButton } from './DownloadBusinessPlanButton';
import { useSurveyWithLocalChanges } from '../hooks/useSurveyWithLocalChanges';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const BusinessPlanReview = (props: { surveyVersion?: number | null; dataTest: string }) => {
  const { surveyVersion, dataTest } = props;

  useAnalyticsPage(Page.BUSINESS_PLAN_REVIEW_AND_DOWNLOAD);
  const {
    query: { data: survey },
  } = useSurveyWithLocalChanges();
  return (
    <div className="business-plan-review__container">
      <div className="business-plan-review__sections">
        {survey.sections.map((x, i) => (
          <div key={x.key} className="business-plan-review__section">
            {(i === 0 || survey.sections[i - 1].section !== x.section) && (
              <div className="business-plan-review__section-header">{x.section}</div>
            )}
            <div className="business-plan-review__subsection-header">{x.subsection}</div>
            <Markdown className="markdown-container" remarkPlugins={[remarkGfm]}>
              {x.value ? x.value : '*No content*'}
            </Markdown>
          </div>
        ))}
      </div>
      <DownloadBusinessPlanButton surveyVersion={surveyVersion} dataTest={dataTest} />
    </div>
  );
};
